import { render } from "./patch24Icon.vue?vue&type=template&id=6f2cc6ba"
const script = {}

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__